var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useContext, useEffect, useState } from 'react';
import 'dayjs/locale/fr-ca';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@material-ui/core';
import dayjs from 'dayjs';
import { usePhoneView } from '@michelin/acid-components';
import { ClosableDialogContent, ClosableDialogTitle } from '../../../compositions/ClosableDialog';
import { CentralProviderContext } from '../../../centralProviderContext/CentralProviderContext';
import { ExpandablePanels } from './ExpandablePanels';
import { processReleaseNotesList } from './utils';
export function ReleaseNotesDialog(props) {
    dayjs.extend(localizedFormat);
    var t = useTranslation().t;
    var releaseNotes = props.releaseNotes, open = props.open, setOpen = props.setOpen;
    var phoneView = usePhoneView();
    var _a = __read(useState(), 2), sortedReleaseNotes = _a[0], setSortedReleaseNotes = _a[1];
    var centralProfile = useContext(CentralProviderContext).centralProfile;
    useEffect(function () {
        // Sort notes by release date
        var sorted = processReleaseNotesList(releaseNotes, centralProfile);
        if (sorted)
            setSortedReleaseNotes(sorted);
    }, [releaseNotes]);
    if (!(sortedReleaseNotes === null || sortedReleaseNotes === void 0 ? void 0 : sortedReleaseNotes.length))
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Dialog, { open: open, onClose: function () { return setOpen(false); }, fullWidth: true, maxWidth: "md", fullScreen: phoneView },
            React.createElement(ClosableDialogTitle, { onClose: function () { return setOpen(false); } }, t("What's New")),
            React.createElement(ClosableDialogContent, { dividers: true, style: { height: phoneView ? undefined : '70vh' } },
                React.createElement(ExpandablePanels, { notes: sortedReleaseNotes })))));
}
//# sourceMappingURL=ReleaseNotesDialog.js.map